/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLineTool = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M19.125 7.875a2 2 0 1 0-1.971-2.338l-6.917 2.766a2 2 0 0 0-2.809 2.809L4.721 17.88a2 2 0 1 0 1.807.867l2.757-6.893a2 2 0 0 0 1.695-1.695l6.867-2.747c.346.289.792.462 1.278.462" /></svg>;
export default SvgLineTool;